var map = {
	"./1.png": "13a5",
	"./2.png": "b151",
	"./3.png": "01a7",
	"./4.png": "67a0",
	"./5.png": "fdd8",
	"./6.png": "507f",
	"./bgc.png": "99c4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bce7";